<script setup lang="ts">
import { IFollowingsResult } from "~/components/layout/Search/SearchResults.vue";

interface IAvatarProps {
	following: IFollowingsResult | { id: string; name: string; type: string } | null;
}

const hasImage = ref(true);

const props = defineProps<IAvatarProps>();

const generateAvatar = computed(() => {
	const names: string[] | undefined = props.following?.name.split(" ").slice(0, 2);
	let returnString = "";

	if (names && names.length === 2) {
		returnString += names[0].substring(0, 1);
		returnString += names[1].substring(0, 1);
	} else {
		returnString = props.following?.name.substring(0, 2) ?? "";
	}
	return returnString.toUpperCase();
});
</script>

<template>
	<div class="w-[32px] h-[32px] bg-light-50 rounded-full overflow-hidden shrink-0 p-[2px]" v-if="hasImage">
		<NuxtImg :src="`${following?.id}@80`" provider="avatar" alt="Profile picture" @error="hasImage = false" class="w-[28px] h-[28px]" />
	</div>
	<div
		v-else
		class="w-[32px] h-[32px] bg-dark-300 dark:bg-light-50 dark:text-dark-600 rounded-full flex items-center justify-center text-light-50 text-[14px] font-bold p-[2px]"
	>
		{{ generateAvatar }}
	</div>
</template>

<style scoped lang="scss"></style>
